// Excuse the eslint exceptions, they seem like false failures to me.
import API from '@app/api';
import Store from '@app/store';
import Actions from '@app/store/action';

const { session } = Store.getState();

const INTERVAL = 1000 * 60 * 10; // every 10 minutes check
const CURRENT_VERSION = session.compatibility_version || false;

/*eslint no-unused-vars: 0*/
let timer = -1;

function setTimer() {
  /*eslint no-use-before-define: 0*/
  timer = setTimeout(performCheck, INTERVAL);
}

async function performCheck() {
  // If we don't know the current version we can't compare.
  if (CURRENT_VERSION === false) {
    return;
  }

  // Ask the API for the current compatibility version.
  let response;
  try {
    response = await API.Platform.getVersion();
  } catch (e) {
    response = false;
  }

  // No OK response, so we can't compare.
  if (response === false || response.status !== 200) {
    return setTimer();
  }

  // Is it the same or do we have newer?
  if (CURRENT_VERSION >= response.body.compatibility_version) {
    return setTimer();
  }

  // Here we are, but now we have to display the compatibility message
  // Probably update something in the store to show this message?
  Store.dispatch(Actions.Session.requireRefresh());
}

export const init = setTimer;
